import { render, staticRenderFns } from "./plame.vue?vue&type=template&id=3f2e6b0c"
import script from "./plame.vue?vue&type=script&lang=ts"
export * from "./plame.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports